import React from 'react';
import moment from 'moment';
import { IFile } from '../../services/api/requests/getAudioList';
import { makeStyles } from '@material-ui/core/styles';
import { deviceMaxWidth } from '../../constants';
import { ReactComponent as PlayCircledInactive } from '../../assets/images/playCircledInactive.svg';
import { ReactComponent as PlayCircledActive } from '../../assets/images/playCircledActive.svg';

interface IProps {
  onClick: (id: number) => void;
}

export default function PlaylistItem(props: IFile & IProps) {
  const { audioTitle, id, isPlaying, date, place, onClick } = props;
  const styles = useStyles();
  const audioDate = moment(date).format('D MMMM, YYYY');
  const audioLocation = place.combine_name;

  const onClickHandler = () => {
    onClick(id);
  };

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        {isPlaying ? (
          <PlayCircledActive onClick={onClickHandler} />
        ) : (
          <PlayCircledInactive onClick={onClickHandler} />
        )}
      </div>
      <div className={styles.textContainer} onClick={() => {}}>
        <div className={styles.title}>{audioTitle}</div>
        <div className={styles.info}>{`${audioDate}, ${audioLocation}`}</div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 30,
    [deviceMaxWidth.size1200]: {
      maxWidth: 600,
    },
  },
  icon: {
    marginRight: 10,
    cursor: 'pointer',
  },
  textContainer: {
    cursor: 'default',
  },
  title: {
    color: '#D0690D',
    fontSize: 20,
    fontFamily: 'Inter',
    fontWeight: 600,

    [deviceMaxWidth.size1440]: {
      fontSize: 18,
    },
    [deviceMaxWidth.size1200]: {
      fontSize: 16,
    },
    [deviceMaxWidth.size500]: {
      color: '#B65D0D',
      fontSize: 16,
      fontWeight: 500,
    },
  },
  info: {
    color: '#828282',
    fontSize: 18,
    fontFamily: 'Inter',
    fontWeight: 400,

    [deviceMaxWidth.size1440]: {
      fontSize: 16,
    },
    [deviceMaxWidth.size1200]: {
      fontSize: 14,
    },
    [deviceMaxWidth.size500]: {
      fontSize: 14,
    },
  },
}));
